if (window.innerWidth < 768) {
    document.addEventListener('DOMContentLoaded', function () {
    const ugcSlider = document.querySelectorAll('.wls-ugc__slider');
        ugcSlider.forEach(function (slider) {
            let main = new Splide(slider, {
                type: 'loop',
                perPage: 2,
                focus: 0,
                gap: 16,
                pagination: false,
                arrows: false,
                breakpoints: {
                    500: {
                        perPage: 1,
                    }
                },
            });

            main.mount();
        });
    });
}
document.addEventListener('DOMContentLoaded', function () {
    const videoWrappers = document.querySelectorAll('.wls-ugc__video');

    videoWrappers.forEach(wrapper => {
        const video = wrapper.querySelector('video');

        if (!video) return;

        wrapper.addEventListener('click', function () {
            const isPlaying = wrapper.classList.contains('is-playing');

            videoWrappers.forEach(otherWrapper => {
                if (otherWrapper !== wrapper) {
                    const otherVideo = otherWrapper.querySelector('video');
                    if (otherVideo) {
                        otherVideo.pause();
                        otherWrapper.classList.remove('is-playing');
                    }
                }
            });

            if (!isPlaying) {
                video.play();
                wrapper.classList.add('is-playing');
            } else {
                video.pause();
                wrapper.classList.remove('is-playing');
            }
        });

        video.addEventListener('ended', function () {
            wrapper.classList.remove('is-playing');
        });
    });
});